import React, { useState, useEffect } from 'react'
import { Button, Flex, ConfigProvider } from 'antd'
import { To, useLocation, useNavigate, useRoutes } from 'react-router-dom'
import routes from '@/routes'
import centerImage from './assets/imgs/titile_noword.png';
import './APP.css'
import { LeftOutlined } from '@ant-design/icons';

const App: React.FC = () => {
  // 获得路由表
  const routeView = useRoutes(routes)
  const navigate = useNavigate()
  const location = useLocation()

  const [selectedButton, setSelectedButton] = useState('试验监控');

  const [showHistoryReplay, setShowHistoryReplay] = useState(false);
  const [isHistoryReplayPage, setIsHistoryReplayPage] = useState(false);


  useEffect(() => {
    // 根据当前路径设置
    if (location.pathname === '/home') {
      setSelectedButton('试验监控');
      setShowHistoryReplay(false);
      setIsHistoryReplayPage(false);
    } else if (location.pathname === '/history') {
      setSelectedButton('历史记录');
      setShowHistoryReplay(false);
      setIsHistoryReplayPage(false);
    } else if (location.pathname === '/historyrecord') {
      setSelectedButton('历史回放')
      setShowHistoryReplay(true);
      setIsHistoryReplayPage(true);
    }
  }, [location.pathname]);

  const handleButtonClick = (page: To, buttonName: React.SetStateAction<string>) => {
    if (location.pathname !== page ) {
      setSelectedButton(buttonName);
      navigate(page);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (<ConfigProvider
    theme={{
      token: {
        // colorText: '#fff',
        // colorBgBase: '#f00',
        // colorBgContainer: 'orange', // 输入框这些生效了
        // colorBgMask: 'orange',
      }
    }}
  >
    <div className='main-container'>
      <Flex className='main-title' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="image-container">
          <img src={centerImage} alt="Center" className="center-image" />
          <div className="center-image-text">配气发生系统</div>

          {isHistoryReplayPage && (
            <div className="back-button-container">
              <Button icon={<LeftOutlined />} onClick={handleBackClick} className="back-button">
                返回上一页
              </Button>
            </div>
          )}

          <div className="button-container">
            <Button
              className={
                `header-button ${selectedButton === '试验监控' ? 'selected' : 'unselected'}`}
              onClick={() => handleButtonClick('/home', '试验监控')}
              // disabled={isHistoryReplayPage}
            >
              试验监控
            </Button>
            <Button
              className={`header-button ${selectedButton === '历史记录' ? 'selected' : 'unselected'}`}
              onClick={() => handleButtonClick('/history', '历史记录')}
              // disabled={isHistoryReplayPage}
            >
              历史记录
            </Button>
            {showHistoryReplay && (
              <Button
                className={`header-button ${selectedButton === '历史回放' ? 'selected' : 'unselected'}`}
                onClick={() => handleButtonClick('/historyrecord', '历史回放')}
              >
                历史回放
              </Button>
            )}
          </div>
        </div>
      </Flex>
      {routeView}
    </div>
    </ConfigProvider>
  )
}

export default App

